import { EachConditionDataKeys } from "atoms/Rtool/mtgAtoms";

type DataRecord = Record<string, Array<number | null>>;

function moveKey(data: DataRecord, from: string, to: string): void {
    if (!(from in data)) return;
    if (!(to in data)) {
        data[to] = data[from];
    }
    delete data[from];
}

export function normalizeEachConditionData(
    datasetKey: EachConditionDataKeys,
    rawData: unknown
): unknown {
    if (!rawData || typeof rawData !== "object" || Array.isArray(rawData)) return rawData;

    const normalized: DataRecord = { ...(rawData as DataRecord) };

    // API側の旧キーが返ってきても、画面凡例とAtomのキーに揃える
    if (datasetKey === "cabin_noise_target") {
        moveKey(normalized, "cabin_noise_pred", "cabin_noise_target");
    }
    if (datasetKey === "mtg_vib_ctr_target") {
        moveKey(normalized, "mtg_vib_ctr_squared_sum", "mtg_vib_ctr_target_squared_sum");
    }
    if (datasetKey === "mtg_vib_target") {
        moveKey(normalized, "mtg_vib_squared_sum", "mtg_vib_target_squared_sum");
    }

    return normalized;
}
